import Vue from 'vue'
import {interceptor as ApiRewrite} from './ApiRewrite'

export default function (http) {
  Vue.http.interceptors.push(ApiRewrite)
}



// WEBPACK FOOTER //
// ./src/components/interceptors/index.js